import { httpsCallable } from 'firebase/functions';
import { databaseId, functions } from '@/lib/firebase';
import type { ProductPrice } from '@/types';
import { revenuecatClient, type RevenueCatUserProfile } from './revenuecatClient';

export const subscriptionService = {
  /** @deprecated RevenueCat is being phased out in favor of Stripe. */
  async configure(uid: string, profile?: RevenueCatUserProfile): Promise<void> {
    return revenuecatClient.configure(uid, profile);
  },

  /** @deprecated RevenueCat is being phased out in favor of Stripe. */
  async getCustomerInfo() {
    return revenuecatClient.getCustomerInfo();
  },

  /** @deprecated RevenueCat is being phased out in favor of Stripe. */
  async presentPaywall() {
    return revenuecatClient.presentPaywall();
  },

  async getStripePrices(): Promise<ProductPrice[]> {
    const callable = httpsCallable<void, { prices: ProductPrice[] }>(functions, 'getStripePrices');
    const result = await callable();
    return result.data.prices;
  },

  async createStripeCheckout(priceId: string, origin?: string): Promise<{ url: string }> {
    const callable = httpsCallable<
      { priceId: string; origin?: string; databaseId: string },
      { url: string }
    >(functions, 'createStripeCheckoutSession');
    const result = await callable({ priceId, databaseId, ...(origin ? { origin } : {}) });
    return result.data;
  },

  async createStripeCustomerPortalSession(origin?: string): Promise<{ url: string }> {
    const callable = httpsCallable<{ origin?: string; databaseId: string }, { url: string }>(
      functions,
      'createStripeCustomerPortalSession'
    );
    const result = await callable({ databaseId, ...(origin ? { origin } : {}) });
    return result.data;
  },

  async syncSubscription(): Promise<{ active: boolean }> {
    const syncSubscriptionCallable = httpsCallable<{ databaseId: string }, { active: boolean }>(
      functions,
      'syncSubscription'
    );
    const result = await syncSubscriptionCallable({ databaseId });
    return result.data;
  },

  async cancelCheckout(): Promise<void> {
    const callable = httpsCallable<{ databaseId: string }, { success: boolean }>(
      functions,
      'cancelStripeCheckout'
    );
    await callable({ databaseId });
  },
};
